<template>
    <template v-if="customer != null">
        <button tabindex="0" class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200">
            <MiscIcon name="user" class="w-6 h-6 lg:w-8 lg:h-8" size="none" />

            <span v-if="label" class="text-base lg:text-lg inline-block leading-6">
                {{ label }}
            </span>
        </button>

        <CustomerGuestNavigation v-if="customer.isGuest" />
        <CustomerNavigation v-else />
    </template>

    <template v-else>
        <button tabindex="0" class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200">
            <MiscIcon name="user" class="w-6 h-6 lg:w-8 lg:h-8" size="none" />
            <span v-if="label" class="text-base lg:text-lg inline-block leading-6">
                {{ label }}
            </span>
        </button>

        <div tabindex="0" class="menu menu-sm dropdown-content left-1/2 translate-x-[-50%] w-64 flex mt-3 p-6 shadow border border-border bg-base-200 rounded-lg z-50 text-center">
            <span class="text-lg text-headline font-semibold pb-2">{{ t('customer.account.headline') }}</span>
            <p class="text-base pb-4">{{ t('customer.login.message') }}</p>
            <MiscLink to="/customer/login" class="btn btn-secondary mb-5">{{ t('customer.login.login') }}</MiscLink>
            <p>oder
                <MiscLink to="/customer/login">
                    <span class="underline text-primary-content lowercase">{{ t('customer.register.register') }}</span>
                </MiscLink>
            </p>
        </div>
    </template>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCustomer } from '#imports'
import { useI18n } from "vue-i18n";

const props = defineProps<{
    label: string,
}>()

const { t } = useI18n()
const customerStore = useCustomer()
const { customer } = storeToRefs(customerStore)
</script>
